import { IntlShape } from 'react-intl';
import { validateRequiredField } from 'utils/validation';
import { validatePasswordStrength } from '../validatePasswordStrength';

export const password = (intl: IntlShape, isLogin = false) => ({
  ...validateRequiredField(intl),
  ...validatePasswordStrength(intl, isLogin),
});
